import { HttpServiceBase } from './http-service-base';

export class AccountActionService extends HttpServiceBase {
  constructor(...rest) {
    super(...rest);
  }

  get(id) {
    return new Promise((resolve, reject) => {
      this.http.get(`v1/accountactions/${id}`)
        .then(data => JSON.parse(data.response))
        .then(response => resolve(response))
        .catch(e => reject(e));
    });
  }

  /**
   * Skapar en engångsnyckel för att logga in i en annan area.
   *
   * Utan mål blir det en LoginAs-nyckel, som gamla Control och Eval löser in.
   * Med target 'control' blir det en LoginControl-nyckel för nya Control, som
   * bara går att lösa in där — och som servern bara skapar för den som har
   * Control eller Finance hos kunden.
   *
   * Med customer (kortnamn) gäller en LoginControl-nyckel den stiftelsen och inte den
   * token är utfärdad för: sidan kan visa en stiftelse med en token för en annan.
   */
  create(target, customer) {
    let url = target ? `/v1/accountactions?target=${encodeURIComponent(target)}` : '/v1/accountactions';
    if (target && customer) url += `&customer=${encodeURIComponent(customer)}`;
    return new Promise((resolve, reject) => {
      this.http.post(url, {})
        .then(data => JSON.parse(data.response))
        .then(response => resolve(response))
        .catch(e => reject(e));
    });
  }

  /**
   * Engångskoden till en LoginControl-nyckel, när stiftelsen kräver lösenord
   * med engångskod och inloggningen gjordes med bara lösenord (apply-system
   * 0023, tillägg 2026-11-04). Rätt kod ger nyckeln; fel kod avvisas med 401.
   */
  verifyControlCode(mfaToken, code) {
    return this.http.post('/v1/accountactions/control/otp', { mfaToken, code })
      .then(data => JSON.parse(data.response))
      .then(response => response.requestKey);
  }

  /**
   * Växlar nyckeln från Mina ansökningar i nya Control mot en JWT. Nyckeln
   * går bara att lösa in en gång.
   */
  redeemWeb(key) {
    return this.http.post('/v1/accountactions/web', { key })
      .then(data => JSON.parse(data.response));
  }
}
